import { SVGExport } from "../SVG/SVGExport";
import { SVGMax } from "../SVG/SVGMax";
import { SVGMin } from "../SVG/SVGMin";
import { SVGExcel } from "../SVG/SVGExcel";


import * as XLSX from "xlsx";
import { api } from "../../services/api";


export function MenuExportacao(props) {

    const handleDownloadExcelApi = async () => {
        try {

            if (props?.RegistrosToExport?.length === 0) {
                return
            }
            // Enviando os dados JSON para o servidor
            const response = await api.post(`/DisponibilidadeMaquinasEquipamentos/api/gerar-excel/${props.NomeGrid}`, props.RegistrosToExport, {
                headers: {
                    'Content-Type': 'application/json'
                },
                responseType: 'blob'
            });

            // Criando um URL temporário para o arquivo Excel
            const url = window.URL.createObjectURL(new Blob([response.data]));

            // Criando um link e clicando nele para iniciar o download
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${props.NomeGrid}.xlsx`);
            document.body.appendChild(link);
            link.click();
        } catch (error) {
            console.error('Erro ao baixar o arquivo Excel:', error);
        }
    };

    const exportToXLSX = async () => {

        if (props?.IsExcelAPI) {
            await handleDownloadExcelApi()
            return
        }

        // seleciona a tabela HTML
        const table = document.getElementById(props.idTable);

        // obtém as linhas e colunas da tabela
        const rows = table.querySelectorAll("tr");
        const cols = rows[0].querySelectorAll("th, td");

        // cria um array de arrays para representar os dados da tabela
        const data = [];

        // adiciona os cabeçalhos da tabela ao array de dados
        const headers = [];
        cols.forEach((col) => {
            headers.push(col.textContent);
        });

        data.push(headers);

        // adiciona as linhas da tabela ao array de dados
        rows.forEach((row) => {
            const rowData = [];
            const cols = row.querySelectorAll("td");

            cols.forEach((col) => {
                rowData.push(col.textContent);
            });
            data.push(rowData);
        });

        // cria um workbook do xlsx
        const workbook = XLSX.utils.book_new();

        // cria uma worksheet com os dados da tabela
        const worksheet = XLSX.utils.aoa_to_sheet(
            data.filter((e) => e.length > 0),
        );

        // adiciona a worksheet ao workbook
        XLSX.utils.book_append_sheet(workbook, worksheet, props.sheet);

        // exporta o workbook para um arquivo xlsx
        XLSX.writeFile(workbook, `${props.filename}.xlsx`);
    };

    return (
        <>

            <div
                className="Acoes"
            >
                {/*{props.onlyCSV === true ?
                    <>
                        <button className="btnCSV Acao" onClick={exportToXLSX}>
                            <SVGExcel width="1.1rem" height="1.1rem" />
                        </button>
                    </>
                    :
                    <div
                        className={`Acao ${props?.hideExport ? '!hidden' : ''}`}
                        onClick={() => props.ExportarComponente()}
                    >
                        <SVGExport color={'gray'} height="1.1rem" width="1.1rem" />

                    </div>
                }*/}

                {props.hideButtons !== true &&
                    (props.onlyCSV === true ? (
                        <>
                            <button
                                className="btnCSV Acao"
                                onClick={exportToXLSX}
                            >
                                <SVGExcel width="1.1rem" height="1.1rem" />
                            </button>
                        </>
                    ) : (
                        <div
                            className="Acao"
                            onClick={() => props.ExportarComponente()}
                        >
                            <SVGExport
                                color={"gray"}
                                height="1.1rem"
                                width="1.1rem"
                            />
                        </div>
                    ))}

                <div className="Acao" onClick={() => props.setFullScreen()}>
                    {props.isFullScreen === false ? (
                        <SVGMax color={"gray"} height="1.1rem" width="1.1rem" />
                    ) : (
                        <SVGMin color={"red"} height="1.1rem" width="1.1rem" />
                    )}
                </div>
            </div>
        </>
    );
}
